module.exports = __webpack_public_path__ + "static/media/medal.864cc3e9.png";